export enum PositionOrderType {
  DIRECT,
  SPAWNED,
}

export namespace PositionOrderType {
  let elements = [PositionOrderType.DIRECT, PositionOrderType.SPAWNED];
  let alias = "com.bcdfx.model.PositionOrderType";

  export function RemoteClass() {
    return alias;
  }

  export function getAllElements() {
    return elements;
  }
}
